import { render } from "./AddMeetingTemplate.vue?vue&type=template&id=6b848e0b&scoped=true"
import script from "./AddMeetingTemplate.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddMeetingTemplate.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddMeetingTemplate.vue?vue&type=style&index=0&id=6b848e0b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b848e0b"]])

export default __exports__